import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import "./WayfairInventoryUpdateModal.scss";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwButton from "../../../shared/OwButton/OwButton";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import IWayfairOnPushInventoryUpdatesDTO from "../../../../models/DTO/IWayfairOnPushInventoryUpdatesDTO";
import IWayfairPushInventoryUpdatesDTO from "../../../../models/DTO/IWayfairPushInventoryUpdatesDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import INotification from "../../../../models/INotification";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

export const WayfairInventoryUpdateModal: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [activePush, setActivePush] = useState(false);
    const [feedKind, setFeedKind] = useState<"DIFFERENTIAL" | "TRUE_UP">("TRUE_UP");

    useEffect(() => {
        props.socket.on(EndpointsEnum.WayfairOnInventoryUpdate, onWayfairInventoryUpdate);
        props.socket.on(EndpointsEnum.Notify, notify);

        return () => {
            props.socket.removeListener(EndpointsEnum.WayfairOnInventoryUpdate, onWayfairInventoryUpdate);
            props.socket.removeListener(EndpointsEnum.Notify, notify);
        };
    }, []);

    const notify = () => {
        setActivePush(false);
    };

    const closeModal = () => {
        props.closeModalFn();
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;

        setFeedKind(value);
    };

    const wayfairInventoryUpdate = () => {
        setActivePush(true);

        const payload: IWayfairPushInventoryUpdatesDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            feedKind,
        };

        props.socket.emit(EndpointsEnum.WayfairInventoryUpdate, payload);
    };

    const onWayfairInventoryUpdate = (data: IWayfairOnPushInventoryUpdatesDTO) => {
        const notification: INotification = {
            message: "successfully_pushed_wayfair_inventory_updates",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        props.notifyFn(null, notification);
        props.closeModalFn();
    };

    return (
        <div className={"WayfairInventoryUpdateModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-cloud-upload-alt"} title={"wayfair_push_inventory"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div className={"mt-3"}>
                <div>
                    <OwLabel title={"update_type"} />
                </div>
                <div className={"mt-2"}>
                    {supplierModel.Supplier_Integration.wayfair_last_inventory_update ? (
                        <div>
                            <OwInputWrapper
                                id={"differential"}
                                type={"radio"}
                                fn={handleChange}
                                name={"update_type"}
                                value={"DIFFERENTIAL"}
                                checked={feedKind === "DIFFERENTIAL"}
                            />
                            <OwLabel title={"differential"} for={"differential"} className={"ms-3"} />
                            {supplierModel.Supplier_Integration.wayfair_last_inventory_update}
                        </div>
                    ) : null}
                    <div>
                        <OwInputWrapper
                            id={"full"}
                            type={"radio"}
                            fn={handleChange}
                            name={"update_type"}
                            value={"TRUE_UP"}
                            checked={feedKind === "TRUE_UP"}
                        />
                        <OwLabel title={"full"} for={"full"} className={"ms-3"} />
                    </div>
                </div>
                <div>
                    <OwButton title={"start"} active={activePush} disableOnActive={true} fn={wayfairInventoryUpdate} />
                </div>
            </div>
        </div>
    );
};
